function getLocale() {
  return 'en';
}

async function loadLanguageModule(locale:string) {
    // if (feature === 'featureA') {
      const languageModule  = await import('./'+locale+'.json');
    //   languageModule.init();
      return languageModule;
    // } else if (feature === 'featureB') {
    //   const { featureB } = await import('./features/featureB.js');
    //   featureB.init();
    // }
  }

export default loadLanguageModule(getLocale());